import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Dashboard from './components/Dashboard/Dashboard';
import QuestionBank from './components/QuestionBank/QuestionBank';
import PaperGenerator from './components/PaperGenerator/PaperGenerator';
import GeneratedPapers from './components/GeneratedPapers/GeneratedPapers';
import ExamCalendar from './components/ExamCalendar/ExamCalendar';
import Templates from './components/Templates/Templates';
import ProfileSettings from './components/Profile/ProfileSettings';
import Login from './components/Auth/Login';
import Header from './components/Layout/Header';
import Sidebar from './components/Layout/Sidebar';
import ItemAnalysis from './components/ItemAnalysis/ItemAnalysis';
import CLOManagement from './components/CLO/CLOManagement';
import TeamManagement from './components/Team/TeamManagement';
import Scoreboard from './components/Scoreboard/Scoreboard';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { WorkspaceProvider } from './contexts/WorkspaceContext';
import ThemeInitializer from './common/ThemeInitializer.jsx';

// Wrapper component to handle auth state
const AppContent = () => {
  const { user, isAuthenticated } = useAuth();
  
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }
  
  return (
    <>
      <Header />
      <Sidebar />
      <main className="content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/question-bank" element={<QuestionBank />} />
          <Route path="/paper-generator" element={<PaperGenerator />} />
          <Route path="/generated-papers" element={<GeneratedPapers />} />
          <Route path="/exam-calendar" element={<ExamCalendar />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/item-analysis" element={<ItemAnalysis />} />
          <Route path="/clo-management" element={<CLOManagement />} />
          <Route path="/team" element={<TeamManagement />} />
          <Route path="/scoreboard" element={<Scoreboard />} />
          <Route path="/profile" element={<ProfileSettings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
};

function App() {
  return (
    <Router>
      <ThemeProvider>
        <ThemeInitializer>
          <AuthProvider>
            <WorkspaceProvider>
              <div className="App">
                <AppContent />
              </div>
            </WorkspaceProvider>
          </AuthProvider>
        </ThemeInitializer>
      </ThemeProvider>
    </Router>
  );
}

export default App;